<template>
	<div class="opted-in-list">
		<button class="betslip__details__row__value__award" @click="open">
			<span class="betslip__details__row__value__award__count">{{
				optedInData.length
			}}</span>
			<svg
				class="betslip__details__row__value__award__icon"
				viewBox="0 0 24 22"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M1.5 20V14H10.5V21.5H3C2.57812 21.5 2.20312 21.3594 1.92188 21.0781C1.64062 20.7969 1.5 20.4219 1.5 20ZM22.5 6.5C22.875 6.5 23.25 6.6875 23.5312 6.96875C23.8125 7.25 24 7.625 24 8V11.75C24 11.9844 23.9062 12.1719 23.7656 12.3125C23.625 12.4531 23.4375 12.5 23.25 12.5H0.75C0.515625 12.5 0.328125 12.4531 0.1875 12.3125C0.046875 12.1719 0 11.9844 0 11.75V8C0 7.625 0.140625 7.25 0.421875 6.96875C0.703125 6.6875 1.07812 6.5 1.5 6.5H3.5625C3.23438 5.9375 3.09375 5.28125 3.09375 4.625C3.09375 3.5 3.46875 2.5625 4.3125 1.71875C5.10938 0.921875 6.09375 0.5 7.21875 0.5C8.15625 0.5 9 0.78125 9.75 1.29688C10.4062 1.76562 11.2031 2.5625 12.0469 3.6875C12.8906 2.5625 13.6406 1.76562 14.3438 1.29688C15.0938 0.78125 15.9375 0.5 16.875 0.5C18 0.5 18.9375 0.921875 19.7812 1.71875C20.5781 2.5625 21 3.5 21 4.625C21 5.28125 20.8125 5.89062 20.5312 6.5H22.5ZM7.21875 6.5H11.25C10.4531 5.375 9.79688 4.48438 9.32812 3.92188C8.85938 3.45312 8.48438 3.125 8.15625 2.9375C7.875 2.84375 7.59375 2.75 7.21875 2.75C6.65625 2.75 6.23438 2.9375 5.85938 3.3125C5.48438 3.6875 5.34375 4.10938 5.34375 4.625C5.34375 5.1875 5.48438 5.60938 5.85938 5.98438C6.23438 6.35938 6.65625 6.5 7.21875 6.5ZM16.875 6.5C17.3906 6.5 17.8125 6.35938 18.1875 5.98438C18.5625 5.60938 18.75 5.1875 18.75 4.625C18.75 4.10938 18.5625 3.6875 18.1875 3.3125C17.8125 2.9375 17.3906 2.75 16.875 2.75C16.5 2.75 16.1719 2.84375 15.9375 2.9375C15.5625 3.125 15.1875 3.45312 14.7656 3.92188C14.25 4.48438 13.5938 5.375 12.8438 6.5H16.875ZM13.5 21.5V14H22.5V20C22.5 20.4219 22.3125 20.7969 22.0312 21.0781C21.75 21.3594 21.375 21.5 21 21.5H13.5Z"
					fill="#A9910B"
				/>
			</svg>
		</button>

		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div class="opted-in-filter" v-if="optedInData.length > 0">
				<div class="opted-in-filter__group">
					<h3 class="opted-in-filter__group__title">Your Opted-In Offers</h3>
					<p class="opted-in-filter__group__desc">
						Select only one for this bet
					</p>
					<div class="opted-in-filter__group__actions">
						<div
							v-for="promo in optedInData"
							:key="promo.promo_id"
							:class="{
								'opted-in-filter__group__action': 1,
								active: promo.promo_id === selectedPromo.promo_id,
							}"
						>
							<button
								class="opted-in-filter__group__action__remove"
								@click="removeOptedInPromo(promo)"
							>
								&times;
							</button>
							<button
								class="opted-in-filter__group__action__apply"
								@click="apply(promo)"
							>
								<span class="opted-in-filter__group__action__name">{{
									promo.promo_name
								}}</span>
								<span class="opted-in-filter__group__action__desc">{{
									promo.description
								}}</span>
								<rules-indicator :rules="promo.rules" />
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="opted-in-filter__buttons">
				<button class="opted-in-filter__reset" @click="reset">Cancel</button>
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
import RulesIndicator from "./RulesIndicator.vue";
export default {
	name: "free-bets-optedIn-list",
	components: { RulesIndicator },
	data() {
		return {
			canShowBottomSheet: false,
		};
	},
	props: {
		optedInData: {
			type: Array,
			required: true,
			default: () => [],
		},
		selectedPromo: {
			type: Object,
			default: () => {},
		},
	},
	methods: {
		open() {
			this.canShowBottomSheet = true;
		},
		apply(promo) {
			this.closeBottomSheet();
			// this.$emit("apply");
			this.$emit("change-promo-option", promo);

			localStorage.setItem("selected-optIn", JSON.stringify(promo));
			window.dispatchEvent(
				new CustomEvent("selected-optIn-changed", {
					detail: {
						storage: localStorage.getItem("selected-optIn"),
					},
				})
			);
		},
		reset() {
			this.closeBottomSheet();
			this.$emit("reset");
			this.$emit("change-promo-option", {});
		},
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
		removeOptedInPromo(promo) {
			let vm = this;
			vm.$store.dispatch("promos/optOutPromo", promo.promo_id);
			vm.$store.dispatch("promos/getPromos");
		},
	},
};
</script>

<style lang="scss">
.opted-in-filter {
	padding: 20px;
	&__buttons {
		padding: 0 10px 0px 10px;
	}
	&__button {
		font-size: var(--font-small);
		border: none;
		background: var(--light-gray);
		color: var(--black);
		border-radius: 25px;
		padding: 5px 10px;
		white-space: nowrap;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-right: 2px;
		&.main {
			margin-right: 20px;
		}
		&__label {
			flex: 5;
		}
		&__caret {
			flex-basis: 10px;
			fill: var(--black);
			margin-left: 5px;
			width: 12px;
			height: 8px;
			margin-bottom: -2px;
		}
		&__icon {
			flex-basis: 10px;
			fill: var(--black);
			margin-right: 5px;
			width: 13px;
		}
	}
	&__container {
		padding: 20px 30px;
		max-height: 60vh;
		overflow-y: auto;
	}
	&__group {
		&__title {
			margin: 0;
			margin-bottom: 5px;
			color: var(--black);
			font-size: var(--font-large);
			text-align: center;
		}
		&__desc {
			margin: 0;
			margin-top: 10px;
			padding-bottom: 15px;
			font-size: var(--font-smallest);
			color: var(--light-black);
			text-align: center;
			font-weight: var(--font-weight-lighter);
		}
		&__actions {
			display: flex;
			flex-direction: column;
		}
		&__action {
			background: none;
			text-align: left;
			border: none;
			padding: 10px;
			color: var(--dark-blue);
			font-size: var(--font-small);
			position: relative;
			padding-right: 5px;
			display: flex;
			flex-direction: row;
			border: 1px solid var(--main-bg-color);
			border-radius: 8px;
			margin-bottom: 5px;
			&.active {
				background-repeat: no-repeat;
				background-position: 97% center;
				background-image: url("data:image/svg+xml,%0A%3Csvg width='14' height='11' viewBox='0 0 14 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4.75781 10.7539C4.86719 10.918 5.03125 10.9727 5.25 10.9727C5.44141 10.9727 5.60547 10.918 5.74219 10.7539L13.8086 2.71484C13.918 2.60547 14 2.44141 14 2.22266C14 2.03125 13.918 1.86719 13.8086 1.73047L12.7969 0.746094C12.6602 0.609375 12.4961 0.527344 12.3047 0.527344C12.1133 0.527344 11.9492 0.609375 11.8125 0.746094L5.25 7.30859L2.1875 4.24609C2.02344 4.10938 1.85938 4.02734 1.66797 4.02734C1.47656 4.02734 1.3125 4.10938 1.20312 4.24609L0.191406 5.23047C0.0546875 5.36719 0 5.53125 0 5.72266C0 5.94141 0.0546875 6.10547 0.191406 6.21484L4.75781 10.7539Z' fill='%2360981A'/%3E%3C/svg%3E%0A");
			}

			&__remove {
				background: none;
				outline: none;
				border: none;
			}
			&__apply {
				background: none;
				outline: none;
				border: none;
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				text-align: left;
				max-width: 90%;
			}
			&__name {
				font-size: var(--font-small);
				margin-bottom: 5px;
			}
			&__desc {
				font-size: var(--font-smallest);
				color: var(--light-black);
				margin-bottom: 5px;
			}
		}
	}
	&__apply {
		background: var(--green);
		font-style: normal;
		font-weight: var(--font-weight-medium);
		font-size: var(--font-medium);
		line-height: 20px;
		border: none;
		padding: 8px 0;
		text-align: center;
		color: var(--always-white);
		display: block;
		width: 100%;
		margin-bottom: 10px;
	}
	&__reset {
		background: none;
		font-style: normal;
		font-weight: var(--font-weight-medium);
		font-size: var(--font-medium);
		line-height: 20px;
		border: none;
		padding: 0 0 10px 0;
		text-align: center;
		color: var(--black);
		display: block;
		width: 100%;
	}
}
</style>
